module.exports = "<svg viewBox=\"1 2 15 13\"><path d=\"M11.8284271,8 L8.58578644,4.75735931 L10,3.34314575 L15.6568542,9 L10,14.6568542 L8.58578644,13.2426407 L11.8284271,10 L5,10 L5,8 L11.8284271,8 L11.8284271,8 Z M1,2 L3,2 L3,6 L1,6 L1,2 Z M5,10 C2.790861,10 1,8.209139 1,6 L3,6 C3,7.1045695 3.8954305,8 5,8 L5,10 Z\" id=\"path-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/arrow-indent-right.svg
// module id = 607
// module chunks = 0